import React, {useState, useEffect} from 'react';

import BlogDataAccess from "../../utils/BlogDataAccess";
import BlogListingLayout from "./BlogListingLayout";
import MetaTagsManipulator from "../../utils/MetaTagsManipulator";

function BlogPage() {
    const [blogDataAccess] = useState(new BlogDataAccess());
    const [availableCategories, setAvailableCategories] = useState(new Map());
    const [allPosts, setAllPosts] = useState(null);

    MetaTagsManipulator.setTitle("Blog");

    useEffect(() => {
        blogDataAccess.getAvailableCategories().then(setAvailableCategories);
        blogDataAccess.getNewPosts().then(setAllPosts);
    }, []);

    return (
        <div id="content">
            <div className="blog2-section">
                <div className="blog2-page-wrapper">
                    <h1 className="blog2-page-title">Blog</h1>

                    <BlogListingLayout
                        heading="Wszystkie artykuły"
                        posts={allPosts}
                        categories={availableCategories}
                        activeCategoryLink={null}
                    />
                </div>
            </div>
        </div>
    );
}

export default BlogPage;
